import React from 'react';

const visioncamUrl = 'https://visioncam.visiontrak.com.au/loginPage';

const Visioncam = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 52,
        right: 0,
        bottom: 0,
        left: 0,
        width: '100%',
        overflow: 'hidden',
        backgroundColor: '#151b2d',
        zIndex: 1,
      }}
    >
      <iframe
        src={visioncamUrl}
        title="Visioncam"
        style={{
          position: 'absolute',
          top: -52,
          left: 0,
          border: 0,
          display: 'block',
          width: '100%',
          height: 'calc(100% + 52px)',
        }}
        allowFullScreen
      />
    </div>
  );
};

export default Visioncam; 
